export default {
  header: 'Informácie o {0}',
  loadData: 'Vsádzka',
  load: 'Vsádzka {0}',
  orderNo: 'Číslo objednávky',
  partNo: 'Číslo dielu',
  partDesc: 'Popis dielu',
  targetQuantity: 'Plánované množstvo',
  actualQuantity: 'Skutočné množstvo',
  singleWeightText: 'Hmotnosť kusu',
  totalWeightText: 'Celková hmotnosť',
  productionOutput: 'Výstup výroby',
  quantityBreak: 'Množstvo lomu',
  quantityCrack: 'Množstvo trhlín',
  quantityNOK: 'Množstvo NOK',
  quantityOK: 'Množstvo OK',
  rightCycleTimeSeconds: 'Správny čas cyklu [s]',
  qmData: 'QS údaje',
  restData: 'Údaje roštu',
  grateNo: 'Číslo roštu',
  spsNo: 'Číslo SPS',
  startTime: 'Čas začiatku',
  endTime: 'Čas konca',
  previousEndTime: 'Predchádzajúci čas konca',
  id: 'ID',
  treatment: 'Spracovanie',
  grateType: 'Typ roštu',
  zoneTimes: 'Časy zón',
  zoneEntranceTime: 'Čas vstupu do zóny',
  zoneExitTime: 'Čas výstupu zo zóny',
  zone1EntryTime: 'Čas vstupu do zóny 1',
  zone1ExitTime: 'Čas výstupu zo zóny 1',
  zone2EntryTime: 'Čas vstupu do zóny 2',
  zone2ExitTime: 'Čas výstupu zo zóny 2',
  specialColor: 'Špeciálna farba',
};
